/**
 * @generated SignedSource<<199ad6d9da0bb6ba2d4b5ab519b1ca3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamMemberContactFragment$data = {
  readonly id: string;
  readonly contact: {
    readonly " $fragmentSpreads": FragmentRefs<"contactFragment">;
  };
  readonly createdAt: any | null;
  readonly updatedAt: any | null;
  readonly deletedAt: any | null;
  readonly " $fragmentType": "teamMemberContactFragment";
};
export type teamMemberContactFragment$key = {
  readonly " $data"?: teamMemberContactFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"teamMemberContactFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "teamMemberContactFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Contact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "contactFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletedAt",
      "storageKey": null
    }
  ],
  "type": "ContactTeamMember",
  "abstractKey": null
};

(node as any).hash = "3315c3beffd4e614fd1c534a26571fd3";

export default node;
